import React from 'react'

export default function Footer() {
    return (
        <footer>
            <small>Developed with <span>ᚹ</span> in Berlin by <code>ᛚᛖᚨᚾᛞᚱᛟ</code></small>
        </footer>
    )
}
